"use client";
import { teamMembers } from "@/data/data";
import TeamAreaCard from "@/components/common/team-area-card";
import Link from "next/link";

const TeamArea = () => {
    return (
        <>
            <section className={`desilo-team-area section-padding-top-bottom`}>
                <div className="container custom-container">
                    <div className="row gx-4 gy-2 align-items-end">
                        <div className="col-md-9 col-xl-7 col-xxl-6">
                            <div className="desilo__header">
                                <h2 className="title text-left text-md-start">
                                    Meet our experts
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 row-padding-top">
                        {/* team card start */}
                        {teamMembers.slice(0, 2).map((item, i) => (
                            <div
                                key={i}
                                className="col-lg-4 col-md-6 col-12"
                            >
                                <Link href={item.link || "#"}>
                                    <TeamAreaCard data={item} />
                                </Link>
                            </div>
                        ))}
                        {/* team card end */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default TeamArea;
